import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lwf-series',
  templateUrl: './lwf-series.component.html',
  styleUrls: ['./lwf-series.component.css']
})
export class LwfSeriesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/lwf-series/lwf-series.component.ts